<template>
	<transition name="el-fade-in-linear">
		<el-dialog
			:title="config.title"
			:visible.sync="show"
			:close-on-click-modal="config.closeOnClickModal"
			:center="config.center"
			@close="close"
		>
			<el-form
				:model="formData"
				:label-width="config.formConfig.labelWidth"
				:rules="formRules"
				ref="formEle"
			>
				
				<!-- 双排布局 -->
				<template v-if="config.formConfig.abreast">
					<el-row v-for="(item, index) in config.formConfig.items" :key="index">
						<el-col :span="12">
							<el-form-item :label="item[0].label"	:prop="item[0].prop">
								<!-- slot -->
								<template v-if="item[0].slot">
									<slot :name="item[0].field"></slot>
								</template>

								<template v-else>
									<!-- input -->
									<template v-if="item[0].type === 'input'">
										<el-input
											v-model="formData[item[0].field]"
											:autocomplete="item[0].autoComplete"
											:placeholder="item[0].placeholder"
										></el-input>
									</template>

									<!-- textarea -->
									<template v-if="item[0].type === 'textarea'">
										<el-input
											v-model="formData[item[0].field]"
											:autocomplete="item[0].autoComplete"
											type="textarea"
											:autosize="item[0].autosize"
											:maxlength="item[0].maxlength"
											:show-word-limit="item[0].showWordLimit"
										></el-input>
									</template>

									<!-- select -->
									<el-select
										v-if="item[0].type === 'select'"
										:multiple="item[0].multiple"
										v-model="formData[item[0].field]"
										:placeholder="item[0].placeholder"
									>
										<el-option
											v-for="items in item[0].option"
											:key="items.id"
											:label="items.name"
											:value="items.id"
										></el-option>
									</el-select>
								</template>
							</el-form-item>
						</el-col>
						<el-col :span="12" v-if="item[1]">
							<el-form-item :label="item[1].label"	:prop="item[1].prop">
								<!-- slot -->
								<template v-if="item[1].slot">
									<slot :name="item[1].field"></slot>
								</template>

								<template v-else>
									<!-- input -->
									<template v-if="item[1].type === 'input'">
										<el-input
											v-model="formData[item[1].field]"
											:autocomplete="item[1].autoComplete"
											:placeholder="item[1].placeholder"
										></el-input>
									</template>

									<!-- textarea -->
									<template v-if="item[1].type === 'textarea'">
										<el-input
											v-model="formData[item[1].field]"
											:autocomplete="item[1].autoComplete"
											type="textarea"
											:autosize="item[1].autosize"
											:maxlength="item[1].maxlength"
											:show-word-limit="item[1].showWordLimit"
										></el-input>
									</template>

									<!-- select -->
									<el-select
										v-if="item[1].type === 'select'"
										:multiple="item[1].multiple"
										v-model="formData[item[1].field]"
										:placeholder="item[1].placeholder"
									>
										<el-option
											v-for="items in item[1].option"
											:key="items.id"
											:label="items.name"
											:value="items.id"
										></el-option>
									</el-select>
								</template>
							</el-form-item>
						</el-col>
					</el-row>
				</template>

				<!-- 单排布局 -->
				<template v-else>
					<el-form-item
						v-for="(item, index) in config.formConfig.items"
						:key="index"
						:label="item.label"
						:prop="item.prop"
					>
						<!-- slot -->
						<template v-if="item.slot">
							<el-col :span="item.span">
								<slot :name="item.field"></slot>
							</el-col>
						</template>

						<template v-else>
							<!-- input -->
							<el-col v-if="item.type === 'input'" :span="item.span">
								<el-input
									v-model="formData[item.field]"
									:autocomplete="item.autoComplete"
									:placeholder="item.placeholder"
								></el-input>
							</el-col>

							<!-- textarea -->
							<el-col
								v-if="item.type === 'textarea'"
								:span="item.span"
							>
								<el-input
									v-model="formData[item.field]"
									:autocomplete="item.autoComplete"
									type="textarea"
									:autosize="item.autosize"
									:maxlength="item.maxlength"
									:show-word-limit="item.showWordLimit"
								></el-input>
							</el-col>

							<!-- select -->
							<el-select
								v-if="item.type === 'select'"
								:multiple="item.multiple"
								v-model="formData[item.field]"
								:placeholder="item.placeholder"
							>
								<el-option
									v-for="items in item.option"
									:key="items.id"
									:label="items.name"
									:value="items.id"
								></el-option>
							</el-select>
						</template>
					</el-form-item>
				</template>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button
					v-for="(btns, btnIndex) in config.footerBtnConfig"
					:key="btnIndex"
					:type="btns.type"
					@click.native="operateFn(btns)"
					:loading="editLoading"
					v-html="btns.name"
				></el-button>
			</div>
		</el-dialog>
	</transition>
</template>
<script>
export default {
	name: "operateDialog",
	data() {
		return {
			editLoading: false,
			show: this.showOperateDialog,
			formData: this.formDatas,
		};
	},
	props: {
		config: {
			type: Object
		},
		formRules: {
			type: Object
		},
		showOperateDialog: {
			type: Boolean
		},
        formDatas:{
            type: Object
        }
	},
	created() {
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		submit() {
			this.$emit('submit', this.formData)
		},

		close() {
			this.$emit('operateCancel', this.config.showOperateControl)
		},

        operateFn(v){
            if(v.name === '取消'){
			    this.close()
            }else{
			    this.$emit(v.event, this.formData)
            }
        }
	},
	watch: {
		formData: {
			handler(n, o) {
			},
			deep: true
		},
		formDatas: {
			handler(n, o) {
                this.formData = Object.assign(this.formData,n)
			},
			deep: true
		}
	},
};
</script>

<style lang="less" scoped>
</style>